import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableExternalInventory = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableExternalInventory);
};
